import React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"

import ActionHandlerRegistry from "../../utils/ActionHandlerRegistry"
import getMessageBaseClasses from "../../utils/MessageUtils"
import { IActionMessage } from "../.."

export interface Props extends IActionMessage {
    isLoading: boolean
}

export default function ActionMessage({
    id,
    content,
    isLoading,
    timestamp: _timestamp,
    type: _type,
    ...args
}: Props): JSX.Element {
    const onClickAction = ActionHandlerRegistry.get(id)

    if (!onClickAction) {
        return <></>
    }

    const classes = getMessageBaseClasses({
        shouldAddNoteTheme: false,
        shouldAddCloudBackground: true,
    })

    return (
        <Action
            extraClasses={classes}
            onClick={onClickAction}
            isLoading={isLoading}
            {...args}
        >
            {content}
        </Action>
    )
}
